export default {
  BUTTON: {
    APPLY: "Применить",
    NONE: "Нет",
    SAVE_CHANGES: "Сохранить изменения",
    PROCEED: "Продолжить",
    DISMISS: "Отклонить",
    CONNECT: "Подключиться",
    CONNECT_WALLET: "Подключить кошелек",
    DISCONNECT: "Отключиться",
    LOGOUT: "Выйти",
    CLOSE: "Закрыть",
    SETTINGS: "Настройки",
    LAUNCH_APP: "Запустить приложение",
    CONNECT_TO_PROCEED: "Подключить кошелек",
    VIEW_DETAILS: "Детали",
    REFRESH: "Обновить",
    START_REGISTRATION: "Начать регистрацию",
    CANCEL: "Отмена",
    PRESS_ENTER: "Нажмите Enter",
    LEARN_MORE: "Узнать больше",
    CLOSE_WINDOW: "Закрыть окно",
    SHOW_AVAILABLE_ONLY: "Показать только доступные",
    SHOW_AVAILABLE: "Показать только доступные",
    PROCEED_SEARCH: "Продолжить поиск",
    DOWNLOAD: "Скачать",
    SHOW_ALL: "Показать все",
    DESELECT_ALL: "Отменить выбор",
    SHOW_SELCTED: "Показать выбранные",
    LINK: "Ссылка",
    CUSTOM_LINK: "Пользовательская ссылка",
    SET_QR_LINK_ALL: "Установить QR ссылку все",
    SET_QR_LINK: "Установить QR ссылку все",
    DISABLE_ALL: "Отключить все",
    DISABLE_QR_CODE: "Отключить QR-код",
    ENABLE_QR_CODE: "Отключить QR-код",
    SET_QR_COLOR: "Установить цвет QR",
    SET_COLOR: "Задать цвет",
    SET_ALL_COLORS: "Установить цвет QR",
    SET_PRICE: "Установить цену",
    SET_PRICE_ALL: "Установить цену для всех",
    RESET: 'Reset',
    CHECK_PROFILE: "Проверить профиль",
    GO_TO_DASHBOARD: "Перейти к панели управления",
    GO_TO_HOME: "Перейти на главную",
    VIEW_PROFILE: "Просмотр профиля",
    CHECK_DOMAINS: "Проверить домены",
    TRANSACTION_DETAILS: "Детали транзакции",
    BUY_NOW: "Купить сейчас",
    CLEAR_HISTORY: "Очистить историю",
    DEFAULT: "По умолчанию",
    CUSTOM: "Своё",
    FRACTIONALISE: "Фракционализация",
    MORE_INFO: "Подробнее",
    LESS_INFO: "Скрыть",
    APPROVE: "Утверждено",
    NEXT: "Следующий",
    PENDING: "В обработке",
    REMOVE: "Удалить",
    REMOVE_ALL_ITEMS: "Удалить все позиции",
    ADD_ALL_TO_CART: "Добавить все в корзину",
    BOOKMARK_ALL: "Отметить все",
    DOWNLOAD_LIST: "Файлы для скачивания",
    SHARE_LIST: "Поделиться списком",
    MORE: "Еще",
    CHANGE: "Редактировать",
    TRY_AGAIN: "Попробовать снова"
  },
  HEADER: {
    ABOUT: "О нас",
    FAQ: "ЧАВО",
    BACK_TO_HOME: "Назад на главную",
    HOME: "Домой",
    CATEGORIES: "Категории",
    HELP_SUPPORT: "Помощь и поддержка",
    HELP: "Помощь",
    CANCEL_REGISTRATION: "Отменить регистрацию",
    PROFILE: "Профиль",
    SETTINGS: "Настройки",
    DOCS: "Документ",
    DOCUMENTATIONS: "Документация",
    CART: "Корзина",
    BOOKMARKS: "Закладки",
    PAYMENTS_HISTORY: "История платежей",
    LIGHT_MODE: "Светлый режим",
    CUSTOM_RPC: "Custom ETH RPC",
    SETUP_REQUIRED: "Требуется настройка",
    MANAGE_DOMAINS: "Управление доменами",
    APPROVE: "Утверждено",
    FEATURE_DISABLED: "Функция отключена",
    ERROR: "Ошибка"
  },
  IPFS: {
    INITIALISING: "Запуск p2p",
    FINDING_PEERS: "Поиск пиров",
    FAILED: "Неудачный",
    READY: "Готово",
    PUBLISHING: "Публикация"
  },
  EVENTS: {
    TRANSFER: "Перевод",
    REGISTRATION: "Регистрация",
    RENEWAL: "Продлить",
    SALE: "Продажа",
    MINT: "Минт",
    BURN: "Сжечь"
  },
  GENERIC: {
    NETWORK_CHANGED_INCOMPATIBLE: "Сеть не поддерживается. Пожалуйста, измените сеть.",
    IPNS_PUBLISHING_COMPLETED: "Публикация завершена!",
    PENDING_TRANSACTION_CERATED: "Была создана новая транзакция. Пожалуйста, проверьте ваш кошелек."
  },
  RENEWAL_DURATIONS: {
    ONE_WEEK: "1 неделя",
    ONE_MONTH: "Месяц",
    THREE_MONTHS: "3 месяца",
    SIX_MONTHS: "6 месяца",
    ONE_YEAR: "1 год",
    TWO_YEARS: "2 года",
    THREE_YEARS: "3 года",
    FOUR_YEARS: "4 года",
    FIVE_YEARS: "5 года"
  },
  LABELS: {
    DOWNLOAD_DATA: "Загрузить данные",
    SORT_BY_EXPIRATIONS: "Сортировать по окончанию",
    SORT_BY_LATEST_REGISTRATIONS: "Сортировать по последним регистрациям",
    SORT_BY_LONGEST_DURATION: "Сортировать по длинной длительности",
    PREMIUM: "Премиум",
    ANALYTICS: "Аналитика",
    AN_ERROR_HAS_OCCURED: "Произошла ошибка при обработке вашего запроса.",
    STOREFRONT_READY_TO_DEPLOY: "Витрина магазина готова к развертыванию. Магазин будет находиться в:",
    ACCESS_STOREFRONT: "Теперь вы можете получить доступ к магазину здесь:",
    BUY_ON: "Купить на",
    MY_PROFILE: "Мой профиль",
    CREATE_STOREFRONT: "Создать витрину",
    SETUP_PRIMARY_DOMAIN: "Настройка первичного домена",
    CHOOSE_A_PRIMARY_DOMAIN: "Выберите основной домен и привяжите его к вашему профилю. Выбранный домен будет ссылкой на ваш профиль.",
    CREATE_YOUR_STOREFRONT: "Создайте витрину магазина с помощью имени .eth в магазинах. Узнайте больше о витрине магазина:",
    THIS_DOMAINS_IS_AVAILABLE_IN_MARKETPLACE: "Этот домен доступен на следующих площадках",
    PURCHASE_DOMAINS: "Покупка доменов",
    OWNED_BY: "Владелец",
    SETUP_STOREFRONT: 'Setup Storefront',
    MANAGE_FEATURED_ITEMS: "Управление рекомендуемыми товарами",
    VISIT_STOREFRONT: "Посетить витрину",
    OPTIONS: "Опции",
    FEATURED_ITEMS: "Рекомендованные пункты",
    SORT_BY_CATEGORY: "Сортировать по категориям",
    SELECT_DOMAIN: "Выбрать домен",
    SELECT_DOMAINS: "Выберите домены",
    RENEW_DOMAINS: "Продлить домены",
    TRANSFER_DOMAINS: "Передача доменов",
    BUYER: "Покупатель",
    PRICE: "Цена",
    SALE: "Продажа",
    ACTIVITY: "Нагрузка",
    TOP_CATEGORIES: "Категории",
    TOTAL_ASSETS: "Итоговые активы",
    MONTHLY_SALES: "Проездной на месяц",
    DAILY_VOLUME: "Дневной объем",
    MONTHLY_VOLUME: "Ежемесячный объем",
    DAILY_SALES: "Ежедневная распродажа",
    TOP_SALE: "Топ продаж",
    TOP_SALES: "Лидеры продаж",
    TOP_BUYER: "Топ Покупатель",
    RECENT_SALES: "Стиль недавних ",
    SALES_ACTIVITY: "Активность продаж",
    ENTER_NAMES_TO_SEARCH: "Введите имена для поиска",
    NOT_AVAILABLE: "Недоступно",
    VOLUME: "Громкость",
    FLOOR: "Пол",
    FILTER: "Фильтр",
    RENEWAL_DURATION: "Продолжительность обновления",
    TRANSACTION: "Транзакция",
    USER_PROFILE: "Профиль пользователя",
    FEATURE_DISABLED: "Эта функциональность на данный момент недоступна",
    COMPLETE: "Готово",
    ESTIMATED_COST: "Предполагаемые затраты",
    ADDRESS: "Адрес",
    TRANSFER: "Перевод",
    PLEASE_WAIT: "Пожалуйста, подождите",
    SELECT_A_DOMAIN: "Выбранные домены",
    RENEW: "Продлить",
    MANAGE_DOMAINS: "Управление доменами",
    SEARCH_FOR: "Поиск",
    MANAGE: "Управлять",
    COLLECT: "Собрать",
    LANDING_TEXT: "Открытый исходный код, децентрализованный поиск доменов Web3, регистрация и рынок.",
    PROFILE: "Профиль",
    GO_TO_PROFILE: "Зайди в профиль",
    SEARCH: "Искать",
    CONTAIN_ALPHABET: "Содержит алфавит",
    CONTAIN_NUMBERS: "Содержит числа",
    CONTAIN_EMOJI: "Содержит смайлы",
    MIN_LENGTH: "Мин. длина",
    MAX_LENGTH: "Макс. длина",
    CONTAINING_KEYWORDS: "Содержащие ключевые слова",
    FILTERS: "Фильтры",
    DOMAINS: "Домены",
    DOMAIN: "Поле",
    DOMAIN_HISTORY: "История доменов",
    EXPIRATION_DATE: "Дата истечения",
    REGISTRATION_DATE: "Регистрация",
    CREATION_DATE: "Дата создания",
    DETAILS: "Детали",
    YOUR_DOMAINS: "Ваши домены",
    PROCESSING: "Обработка",
    LAYOUT: "Макет",
    ENTER_SUFFIX: "Введите суффикс",
    ENTER_PREFIX: "Укажите префикс",
    CLICK: "Нажать",
    CONNECT_TO_START: " начать или ",
    TIP: 'Tip',
    ACTION: "Действие",
    ACTIONS: "Действия",
    ADVANCED_SEARCH_TIP: "используйте новую строку или запятую для разделения ваших доменных записей.",
    ADVANCED_SEARCH: "Усовершенствованный поиск",
    ADVANCED_MODE: "Расширенный режим",
    REGISTER_DOMAINS_TO: "Регистрация доменов для",
    NO_DOMAINS_SELECTED: "Домены не выбраны.",
    FIND_AND_REGISTER: "Поиск доменов, например домена1, домена2...",
    SELECTED_DOMAINS: "Выбранные домены",
    REGISTER: "Регистрация",
    BOOKMARKS: "Закладки",
    SEARCH_RESULTS: "Результаты поиска",
    PROCEED_TO_REGISTRATION: "Перейти к регистрации",
    REGISTER_DOMAINS: "Регистрация доменов для",
    REGISTRANT_ADDRESS: "Регистрационный адрес",
    SET_RESOLVER: "Установить резолвер",
    TOTAL_COST: "Общая стоимость",
    GAS_PRICE: "Цена газа",
    NO_ADDRESS_DETECTED: "Адрес не обнаружен.",
    DURATION: "Продолжительность",
    NOTICE_SELECT_AN_RPC: "Примечание: выберите RPC, который будет использоваться в приложении для замены поставщика RPC по умолчанию.",
    ENABLE_LIGHT_MODE: "Включить светлый стиль.",
    CLICK_NEXT_TO_PROCEED: "Нажмите <b>Далее</b> , чтобы продолжить."
  },
  REGISTRATION: {
    REGISTRATION_CANCELLED_TITLE: "Регистрация отменена",
    REGISTRATION_CANCELLED_DESCRIPTION: "Ваша регистрация была отменена.",
    CANCEL_REGISTRATION_TITLE: "Отменить регистрацию",
    CANCEL_REGISTRATION_DESCRIPTION: "Вы уверены, что хотите удалить регистрацию этого проекта? Это действие будет невозможно отменить.",
    BEFORE_COMMIT: "Шаг 1: запрос на регистрацию.",
    COMMIT_SENT: "Обработка запроса...",
    COMMIT_COMPLETE: "Шаг 1: запрос на регистрацию...",
    AWAIT: "Обработка запроса...",
    BEFORE_REGISTRATION: "Окончание регистрации",
    REGISTRATION_SENT: "Завершение регистрации...",
    REGISTRATION_COMPLETE: "Регистрация!",
    REGISTRATION_COMPLETE_TITLE: "Регистрация завершена",
    YOUR_DOMAINS_HAVE_NOW_BEEN_REGISTERED: "Ваши домены зарегистрированы.",
    BASKET_EMPTY: "Ваша корзина пуста",
    PLEASE_SELECT_DOMAINS_TO_REGISTER: "Пожалуйста, выберите новые домены для регистрации."
  },
  PAYMENT: {
    PAYMENT_CANCELLED: "Транзакция отменена. Пожалуйста, попробуйте еще раз."
  },
  SPINNER: {
    SETUP_COMPLETE: "Установка завершена",
    LEDGER_NO_DEVICE_SELECTED: "Произошла ошибка при подключении к вашему кошельку. Пожалуйста, попробуйте еще раз.",
    NO_DATA_TO_DISPLAY: "Нет элементов для отображения.",
    PERFORMING_SEARCH: "Выполняется поиск...",
    LOADING_DATA: "Загрузка данных...",
    FOLLOW_THE_INSTRUCTIONS_ON_YOUR_WALLET: "Чтобы продолжить, следуйте инструкциям в вашем кошельке."
  },
  FORM_LABELS: {
    ENTER_DURATION: "Введите длительность",
    ENTER_QR_LINK: "Введите свой QR-код URL",
    ENTER_PRICE: "Введите цену",
    ENTER_CUSTOM_ADDRESS: "Введите свой адрес",
    ENTER_RECEIVER_ADDRESS: "Введите адрес получателя"
  },
  FORM_ERRORS: {
    INVALID_DURATION: "Неверная длительность",
    INVALID_QR_LINK: "Неправильный URL, попробуйте еще раз.",
    INVALID_PRICE: "Неправильная цена, попробуйте еще раз.",
    NO_ADDRESS_DETECTED: "Адрес не обнаружен, попробуйте еще раз.",
    INVALID_ADDRESS: "僅用於中文"
  },
  STEP: {
    STEP_1: "Шаг 1",
    STEP_2: "Шаг 2",
    STEP_3: "Шаг 3",
    STEP_4: "Шаг 4",
    STEP_5: "Шаг 5"
  },
  RENEW: {
    RENEWAL_COST: "Стоимость обновления",
    ESTIMATED_RENEWAL_COST: "Ниже приведены оценочные расходы на продление данной сделки.",
    RENEWAL_COMPLETE: "Обновление завершено",
    DOMAINS_READY_FOR_RENEWAL: " Ваши домены теперь готовы к обновлению. Чтобы завершить обновление, нажмите продолжить."
  },
  TRANSFER: {
    TRANSFER_TO: "Перевод",
    TRANSFER_COMPLETE: "Перевод завершен",
    SETUP_INSTRUCTION: "Чтобы включить управление доменами ENS, ваша учетная запись должна быть настроена на утверждение переноса домена.",
    CONTRACT_APPROVAL_NOTE: "Одобрение договора позволяет выполнять передачу доменов от Вашего имени.",
    DOMAINS_READY_FOR_TRANSFER: "Теперь ваши домены готовы для передачи. Введите адрес получателя и нажмите продолжить."
  }
};